// extracted by mini-css-extract-plugin
module.exports = {"overlay":"NetworkConnectivity_overlay__3kJQA","container":"NetworkConnectivity_container__3LuS-","textLabel":"NetworkConnectivity_textLabel__2YnFR"};